import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useTldrawUiComponents } from "../../context/components.mjs";
function DefaultPeopleMenuContent({ userIds }) {
  const { PeopleMenuItem, UserPresenceEditor } = useTldrawUiComponents();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    UserPresenceEditor && /* @__PURE__ */ jsx("div", { className: "tlui-people-menu__section", children: /* @__PURE__ */ jsx(UserPresenceEditor, {}) }),
    PeopleMenuItem && userIds.length > 0 && /* @__PURE__ */ jsx("div", { className: "tlui-people-menu__section", children: userIds.map((userId) => {
      return /* @__PURE__ */ jsx(PeopleMenuItem, { userId }, userId + "_presence");
    }) })
  ] });
}
export {
  DefaultPeopleMenuContent
};
//# sourceMappingURL=DefaultPeopleMenuContent.mjs.map
